import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationParticipantCreated.vue";

export const selector = (item: Notification): boolean => {
  return item.type === NotificationType.PARTICIPANT_CREATED;
};
